export default "__VITE_ASSET__f112a0f1__"